<button role="button" type="button" (click)="backBtn()"
  class="dds__btn  dds__btn-sm  dds__btn-secondary dds__text-truncate">
  <svg class="dds__svg-icons" aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
    <use xlink:href="#dds__arrow-left" />
  </svg>

  Back</button>


  <div *ngIf="isFetching || isContentFetching || isAttachmentUploading"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"  >
    <div class="dds__modal-dialog" role="document">
      <div class="dds__modal-content">
        <div class="dds__modal-body dds__text-center">
          <div class="dds__mb-3" id="modalId">
            <div class="dds__progress-bar">
              <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
                role="progressbar" data-showtext="true"></div>
            </div>
          </div>
          <p>Processing... Please wait.</p>
          <p *ngIf="isAttachmentUploading">{{percentage}}%</p>
        </div>
      </div>
    </div>
  </div>

<div [hidden]="isFetching">
  <div class="dds__h1" style="text-align: center;">DLO Knowledge Base Editor</div>
  <form data-toggle="dds__form-validation" novalidate="false" [formGroup]="form">
    <div class="dds__form-group">
      <label for="titleInput">Title</label>
      <input type="text" class="dds__form-control" minlength="3" maxlength="256" formControlName="Title" id="titleInput"
        required aria-invalid="false" placeholder="Give a brief descriptive title">
      <div *ngIf="form.get('Title').invalid && submit_req" style="color: #ce1126;"> Please enter title of minimum three characters.</div>
    </div>


    <div class="editor dds__form-group ">
      <label>Article</label>
      <div class="dds__form-row">
        <div class="dds__form-group dds__col-4">
        <div [hidden]="isContentFetching" class="dds__btn-toggle-container">
          <label id="toggleLabel">Auto Save Article Content: </label>
        <button class="dds__btn-toggle-container dds__btn-toggle" type="button"  (click)="enableAutoSave()"  type="button" data-toggle="dds__button" role="switch" aria-checked="true" aria-label="Auto Save" style="visibility: visible;"   title="Auto Save">
        <span class="dds__toggle-txt-off" aria-hidden="false">Disable</span>
        <span class="dds__toggle-txt-on" aria-hidden="true">Enable</span>
        <span class="dds__toggle-circle"></span>
        </button>
        </div>
        </div>
        <div class="dds__form-group dds__col-8">
        <span  class="dds__float-right" *ngIf="isAutoSave" >{{autoSaveStatus}} </span>
        </div>
        </div>

      <app-text-editor  #content (htmlContentToSaveBack)="receiveContentFromEditor($event)" (htmlContentChangeEvent)="htmlContentChangeEventFunction($event)"  [savedHtmlContent]="savedContent" ></app-text-editor>
      <div style="color: #ce1126;" *ngIf="(!contentRec || contentRec=='<br>') && submit_req">Article content cannot be empty!
      </div>
      <div style="color: #ce1126;" *ngIf="(ArticleSizeExceeded)">Article content cannot be greater than 20MB!</div>
      <!-- <div style="color: #ce1126;" *ngIf="(ArticleSizeExceeded)">Article content cannot be greater than {{contentLimit}}MB!</div> -->
    </div>

    <!-- <div class="dds__form-group">
      <label for="tagsInput">Tags</label>
      <input autocomplete="off" (change)="onDocPicked($event)" type="text" class="dds__form-control" maxlength="256"
        formControlName="tags" id="tagsInput" required aria-invalid="false" placeholder="Give space seperated tags">
      <div class="dds__invalid-feedback">Give minimum one tag.</div>

      <div class="top_space" *ngIf="form.get('tags').value">
        <span>Tagged as: </span>
        <span>
          <div type="text" *ngFor="let i of tagsArr()"
            class="dds__btn dds__btn-secondary dds__btn-sm dds__filter-btn-clear tag "
            (click)="removeTag(i,form.get('tags').value)">{{i}}
            <i style="font-weight: bold;padding-left: 5px;" class="dds__icons dds__close-x"></i>
          </div>
        </span>
      </div>

      <div class="top_space" *ngIf="form.get('content').value || form.get('title').value">
        <label for="suggestTags" class="tag">Suggested Tags: </label>
        <span id="suggestTags" class="dds__btn dds__btn-secondary dds__btn-sm dds__filter-btn-clear tag"
          *ngFor="let i of suggestedTags()"
          (click)="(tagsArr() && tagsArr().includes(i))? ' ': addSuggestedTag(i,form.get('tags').value)" [ngStyle]="{'color':(tagsArr() && tagsArr().includes(i))?'grey':'#408001',
                            'cursor':(tagsArr() && tagsArr().includes(i))?'not-allowed': 'pointer',
                            'opacity':(tagsArr() && tagsArr().includes(i))?0.5:1}">
          <i style="font-weight: bold;" class="dds__icons dds__add-cir"></i>
          {{i}}</span>
      </div>


    </div> -->



    <div>
      <div *ngIf="!isFetching && existingDocUrl && mode==='edit'" class="attachment-preview">
        <h5 class="dds__h5">Existing uploaded attachment: </h5>
        <iframe *ngIf="existingDocUrl" [src]="existingDocUrl | safe" alt="article.Title" frameborder="0">
        </iframe>
        <h5 class="dds__btn-link removeFile" (click)="removeExistingDoc()">Remove existing attachment</h5>
      </div>

      <div id="uploadInputDiv" class="dds__form-group dds__form-group-upload">
        <label for="uploadInput">Attachment:</label>
        <div class="dds__form-upload-wrapper">
          <input type="file" class="dds__form-upload" data-toggle="dds__form-upload"
            name="upload" id="uploadInput"  tabindex="-1"
            onclick="value = null"  (change)="onDocPicked($event)" />
          <Button type="button" for="uploadInput" class="dds__form-upload-btn">
            <svg class="dds__svg-icons dds__icon-grid-item customSvg" aria-hidden="true">
                <use xlink:href="#dds__upload" />
            </svg>Upload</Button>
        </div>
        <div class="dds__invalid-feedback" id="uploadInputFeedback"> Please upload attachment. </div>

        <div class="attachment-preview"
          *ngIf="AttachmentPreview !='' && AttachmentPreview && form.get('AttachmentUrl').valid">
          <h5 *ngIf="mode==='edit' && AttachmentPreview !='' && AttachmentPreview && form.get('AttachmentUrl').valid">Attachment
            to be uploaded:
          </h5>
          <div class="" [innerHTML]="SanitizeData(docdata)"></div>
          <!-- <iframe [src]="AttachmentURL | safe"  frameborder="0">
          </iframe> -->
        </div>

      </div>
    </div>


    <fieldset>
      <div class="dds__form-group">
        <label style="margin-right: 10px;">Access level: </label>
        <div class="dds__form-check dds__form-check-inline"> <label class="dds__form-check-label"
            for="AccesslevelRadio1">
            <input class="dds__form-check-input dds__form-control" type="radio" required aria-invalid="false"
              formControlName="Accesslevel" name="Accesslevel" id="AccesslevelRadio1" [value]="Public">
            <span>Public</span> </label></div>
        <div class="dds__form-check dds__form-check-inline"> <label class="dds__form-check-label"
            for="AccesslevelRadio2">
            <input class="dds__form-check-input dds__form-control" type="radio" required aria-invalid="false"
              formControlName="Accesslevel" name="Accesslevel" id="AccesslevelRadio2" [value]="Restricted">
            <span>Restricted</span> </label></div>
        <div style="color: #ce1126;" *ngIf="form.get('Accesslevel').invalid && submit_req">Please choose Access
          Level.
        </div>
      </div>
    </fieldset>

    <div class="dds__d-flex dds__flex-wrap">
      <div>
        <div class="dds__form-group">
          <div class="dds__datepicker dds__mr-2" id="StartDate" data-target="#StartDateCalender">
            <label for="txtStartDate">Start Date</label>
            <div class=" dds__datepicker-form">
              <input formControlName="ScheduledStartDate" (change)="startDateChange($event)" type="text"
                class="dds__form-control dds__input-masked dds__datepicker-input"
                pattern="(0[1-9]|1[0-2])\/([0-2]{1}[0-9]{1}|[3]{1}[0-1]{1})\/[0-9]{4}" data-charset="XX/XX/XXXX"
                maxlength="10" name="StartDate" id="txtStartDate" aria-required="true" required aria-invalid="false"
                aria-describedby="" />
              <button class="dds__datepicker-btn" aria-label="select date" type="button" id="btnStartDate">
                <svg class="dds__calendar" aria-hidden="true" focusable="false">
                  <use xlink:href="#dds__calendar"></use>
                </svg>
              </button>
            </div>
            <small class="dds__form-text dds__text-muted"> Date format mm/dd/yyyy. </small>
            <!-- <div class="dds__invalid-feedback" id="StartDateFeedback"> Please choose a valid Start Date from the
              calendar. </div> -->
            <div class="dds__calendar-wrapper dds__hide">
              <div id="StartDateCalender" class="dds__datepicker-calendar dds__d-none" tabindex="0"></div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="dds__form-group ">
          <div class="dds__datepicker dds__mr-2" id="EndDate" data-target="#EndDateCalender">
            <label for="txtEndDate">End Date</label>
            <div class=" dds__datepicker-form">
              <input formControlName="ScheduledEndDate" (change)="endDateChange($event)" type="text"
                class="dds__form-control dds__input-masked dds__datepicker-input"
                pattern="(0[1-9]|1[0-2])\/([0-2]{1}[0-9]{1}|[3]{1}[0-1]{1})\/[0-9]{4}" data-charset="XX/XX/XXXX"
                maxlength="10" name="EndDate" id="txtEndDate" placeholder=""/>
              <button class="dds__datepicker-btn" aria-label="select date" type="button" id="btnEndDate">
                <svg class="dds__calendar" aria-hidden="true" focusable="false">
                  <use xlink:href="#dds__calendar"></use>
                </svg>
              </button>
            </div>
            <small class="dds__form-text dds__text-muted"> Date format mm/dd/yyyy. </small>
            <div class="dds__calendar-wrapper dds__hide">
              <div id="EndDateCalender" class="dds__datepicker-calendar dds__d-none" tabindex="0"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="color: #ce1126;" *ngIf="startDateError">{{startDateError}}</div>
    <div style="color: #ce1126;" *ngIf="endDateError">{{endDateError}}</div>



    <br>
    <!-- Adding type="button" helps in removing the unnecessary red border on the enddates -->
    <button class="dds__btn dds__form-check-inline dds__btn-secondary" (click)="onSaveArticle(article && article.Status?article.Status:Drafted,'')"  type="button" name="saveForLater"
      value="saveForLater">Save for later </button>

    <button *ngIf="RoleName==Publisher" (click)="openDialog(PendingApproval)" type="button" class="dds__btn dds__form-check-inline  dds__btn-primary" >Save and Submit </button>

    <button *ngIf="RoleName==Moderator" (click)="openDialog(Published)" type="button" class="dds__btn dds__form-check-inline  dds__btn-success" >Save and Approve </button>

    <button *ngIf="RoleName==Moderator && article && article.Status==PendingApproval" type="button" (click)="openDialog(Rejected)" class="dds__btn dds__btn-primary dds__form-check-inline" >Save and Reject </button>

</form>
</div>
